const universalClickSchema = {
  type: 'object',
  properties: {
    event_name: { type: 'string', const: 'click' },
    tealium_event: { type: 'string', default: 'click' },
    event_type: { type: 'string', default: 'click' },
    brand: { type: 'string', nullable: true },
    category_id: { type: 'string', nullable: true },
    category_name: { type: 'string', nullable: true },
    collection_id: { type: 'string', nullable: true },
    inventory: { type: 'string', nullable: true },
    key_item_color: { type: 'string', nullable: true },
    long_sku: { type: 'string', nullable: true },
    parent_category_id: { type: 'string', nullable: true },
    price_flag: { type: 'string', nullable: true },
    price_list_local: { type: 'string', nullable: true },
    price_list_usd: { type: 'string', nullable: true },
    price_offer_local: { type: 'string', nullable: true },
    price_offer_usd: { type: 'string', nullable: true },
    product_badge: { type: 'string', nullable: true },
    product_group: { type: 'string', nullable: true },
    product_id: { type: 'string', nullable: true },
    product_name: { type: 'string', nullable: true },
    product_rating: { type: 'string', nullable: true },
    quantity: { type: 'string', nullable: true },
    short_descriptor: { type: 'string', nullable: true },
    short_sku: { type: 'string', nullable: true },
    swatch_color: { type: 'string', nullable: true },
    // end alphabetized product data
    product_view_method: { type: 'string', nullable: true },
    page_view_method: { type: 'string', nullable: true },
    page_finding_method: { type: 'string', nullable: true },
    data_text: { type: 'string', nullable: true },
    data_action: { type: 'string', nullable: true },
  },
  required: [
    'event_name',
    'tealium_event',
    'event_type',
    'brand',
    'category_id',
    'category_name',
    'collection_id',
    'inventory',
    'key_item_color',
    'long_sku',
    'parent_category_id',
    'price_flag',
    'price_list_local',
    'price_list_usd',
    'price_offer_local',
    'price_offer_usd',
    'product_badge',
    'product_id',
    'product_name',
    'product_rating',
    'quantity',
    'short_descriptor',
    'short_sku',
    'swatch_color',
    'product_view_method',
    'page_view_method',
    'page_finding_method',
    'data_text',
    'data_action',
  ],
  additionalProperties: true,
};

export default universalClickSchema;
